enum LoanType {
  BOLIGLAAN = 'BOLIGLÅN',
  DNB_FORBRFIN = 'DNB FORBRFIN',
  FORBRFIN_AGENT_GML = 'FORBRFIN AGENT GML',
  FORBRFIN_AGENT_NY = 'FORBRFIN AGENT NY',
  SAGA_LIKV_RESERVE = 'SAGA LIKV RESERVE',
  FASTRENTELAAN = 'FASTRENTELÅN',
  RAMMELAAN = 'RAMMELÅN',
  MELLOMFINANSIERING = 'MELLOMFINANSIERING',
}

// This represents the product types we handle "specially" in our apps.
// The enum is not extensive. It exists more types.
enum ProductType {
  AKSJESPAREKONTO = 'AKSJESPAREKONTO',
  BSU = 'BSU',
  BSU_START = 'BSU START',
  DEPOSITUMSKONTO = 'DEPOSITUMSKONTO',
  SPAREKONTO_PLUSS = 'SPAREKONTO PLUSS',
  SUPERSPAR = 'SUPERSPAR',
  BRUKSKONTO_AKSJE = 'BRUKSKONTO AKSJE',
  LEVE_BRUKSKONTO = 'LEVE BRUKSKONTO',
  SPAREKONTO = 'SPAREKONTO',
  STUDENT_BRUKSKONTO = 'STUDENT BRUKSKONTO',
  SAGA_PLATINUM_MC = 'SAGA PLATINUM MC',
  SAGA_GULL_MC = 'SAGA GULL MC',
  UTSATT_BETALING = 'UTSATT BETALING',
}

const AccountProductType = {
  ...LoanType,
  ...ProductType,
};

export default AccountProductType;
